module.exports = __webpack_public_path__ + "assets/img/6.a38cf461.png";